// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';
import { rootStore } from 'store/root';

const history = createBrowserHistory({ basename: process.env.REACT_APP_BASE_URL });
const { application } = window;

history.listen(location => {
    window.dataLayer.push({
        page: `/launcher/${application.params.region_code}/${rootStore.systemInfo.locale.toLowerCase()}${location.pathname}`,
    }); // /launcher/west/en-us/...
});
export default history;
